import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of, timer } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';

export const loginRedirectGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const unifiedAuthService = inject(AuthenticationService);
  const router = inject(Router);
  
  return timer(100).pipe(
    map(() => {
      const isAuthenticated = unifiedAuthService.isUserAuthenticated();
      if (isAuthenticated) {
        const returnUrl = '/';
        router.navigate([returnUrl]);
        return false; 
      }
      return true;
    }),
    catchError(() => {
      return of(true);
    })
  );
};
